import { NgModule, Optional, SkipSelf } from '@angular/core'
import { CommonModule } from '@angular/common'
import { AppTranslateModule } from './translate/translate.module'
import { MessageModule } from './message/message.module'
import { BaseComponent } from './base.component'
import { NetworkModule } from './network/network.module'
import { MatSnackBarModule } from '@angular/material/snack-bar'

@NgModule({
  imports: [
    CommonModule,
    AppTranslateModule,
    MessageModule.forRoot(),
    NetworkModule.forRoot(),
    MatSnackBarModule
  ],
  declarations: [BaseComponent]
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    if (parentModule) {
      throw new Error(
        'CoreModule is already loaded. Import it in the AppModule only'
      )
    }
  }
}
